import { useGetChampionshipQuery } from "championship/api/championship.api";
import { useParams, useLocation } from "react-router-dom";

import { ChampionshipAdminForm } from "../components/forms/ChampionshipAdminForm";

import QueryWrapper from "common/components/QueryWrapper";

export function ChampionshipAdminView() {
  const { championshipId } = useParams<{ championshipId: string }>();
  const location = useLocation();
  const isDuplicate = location.pathname.endsWith("/duplicate");

  const query = useGetChampionshipQuery(championshipId!, {
    skip: !championshipId,
  });

  return (
    <>
      {championshipId ? (
        <QueryWrapper query={query}>
          {(championship) => (
            <ChampionshipAdminForm
              championship={championship}
              editMode={!isDuplicate}
            />
          )}
        </QueryWrapper>
      ) : (
        <ChampionshipAdminForm editMode={false} />
      )}
    </>
  );
}
